declare namespace $ {

	type $mol_view__sub_bog_blitz_admin_quiz_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string_button__hint_bog_blitz_admin_quiz_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_admin_quiz_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_quiz['quiz_title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_quiz_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_quiz_5 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_quiz['share'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_quiz_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_quiz_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_quiz['duplicate'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_quiz_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_quiz_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_quiz['edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_bog_blitz_admin_quiz_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_admin_quiz_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_quiz['start'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_bog_blitz_admin_quiz_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_quiz_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_quiz['delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $bog_blitz_admin_quiz extends $mol_row {
		Shared_icon( ): $mol_icon_share
		Shared_badge( ): $mol_view
		quiz_title( next?: string ): string
		Title_input( ): $mol_string_button
		share( next?: any ): any
		Share( ): $mol_button_minor
		duplicate( next?: any ): any
		Duplicate( ): $mol_button_minor
		edit( next?: any ): any
		Edit( ): $mol_button_minor
		start( next?: any ): any
		Start( ): $mol_button_major
		delete( next?: any ): any
		Delete( ): $mol_button_minor
		is_shared( ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=quiz.view.tree.d.ts.map